import dayjs from "$routes/_lib/dayjs";
import { Box, makeStyles, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles(() => ({
  h1: {
    fontSize: 14,
    marginBottom: 5,
  },
  h2: {
    fontSize: 14,
    marginBottom: 5,
  },
  container: {
    display: "flex",
    justifyContent: "space-between",
  },
}));

const Header = ({ invoice }) => {
  const {
    invoiceNumber,
    patientType = "Outpatient",
    facility,
    created,
  } = invoice;

  const classes = useStyles();

  return (
    <Box>
      <Box className={classes.container}>
        <Typography className={classes.h1}>
          <strong>{facility.name}</strong>
        </Typography>
        <Box flexDirection="column">
          <Typography className={classes.h2}>
            <strong>
              <FormattedMessage
                id="printableInvoice.invoiceNumber"
                defaultMessage="Invoice no.:"
                values={{ patientType }}
              />
            </strong>
            {` ${invoiceNumber}`}
          </Typography>
          <Typography className={classes.h2}>
            <strong>
              <FormattedMessage
                id="printableInvoice.invoicedOn"
                defaultMessage="Invoiced on:"
              />
            </strong>
            {` ${dayjs(new Date(created)).format("DD/MM/YYYY")}`}
          </Typography>
        </Box>
      </Box>
      <Typography className={classes.h2}>
        <FormattedMessage
          id="printableInvoice.invoiceType"
          defaultMessage={`{patientType, select,
            Outpatient {Outpatient}
            Inpatient {Inpatient}
            other {Unknown}
          } Invoice`}
          values={{ patientType }}
        />
      </Typography>
    </Box>
  );
};

Header.propTypes = {
  invoice: PropTypes.shape({
    invoiceNumber: PropTypes.string,
    patientType: PropTypes.string,
    created: PropTypes.string,
    facility: PropTypes.shape({
      name: PropTypes.string,
    }),
  }).isRequired,
};

export default Header;
